// extracted by mini-css-extract-plugin
export default {"info-box":"home_info-box__5iujd","card":"home_card__P2Bk5","card1":"home_card1__hbFq+","card2":"home_card2__3NC6i","card3":"home_card3__qKWS-"};